import { createFileRoute } from '@tanstack/react-router';

import { R1View } from '../../raporty/r1/R1View';

export const Route = createFileRoute('/raporty/r1')({
  component: R1View,
});
